export default `query GetReportDataItem($itemIds: [String]!) {
  getReportDataItem(itemIds: $itemIds) {
    items {
      item_id
      currency
      price
      href
    }
  }
}`;
